export default function Impressum() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-white">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-4xl font-serif font-bold text-gray-900 mb-8">Impressum</h1>
        
        <div className="prose prose-lg max-w-none">
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Angaben gemäß § 5 TMG</h2>
          
          <p className="mb-4">
            <strong>Love yourself beauty by Meltem</strong><br />
            Inh. Meltem Tiryaki<br />
            Wilhelm-Strauß-Weg 2B<br />
            21109 Hamburg
          </p>
          
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Kontakt</h2>
          <p className="mb-4">
            Telefon: +49 (0)40 524 794 72<br />
            Mobil: +49 (0)162 567 6111<br />
            E-Mail: <a href="mailto:mail@loveyourselfbeauty.de" className="text-pink-600 hover:text-pink-700">mail@loveyourselfbeauty.de</a><br />
            Web: <a href="https://lyb-beauty.de" className="text-pink-600 hover:text-pink-700">www.lyb-beauty.de</a>
          </p>
          
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Registereintrag</h2>
          <p className="mb-4">
            Steuernummer: 11/46/064/01944
          </p>
          
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Umsatzsteuer-ID</h2>
          <p className="mb-4">
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
            nicht vorhanden
          </p>
          
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Berufsbezeichnung</h2>
          <p className="mb-4">
            Berufsbezeichnung: Kosmetikerin<br />
            Verliehen in: Deutschland
          </p>
          
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">EU-Streitschlichtung</h2>
          <p className="mb-4">
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-pink-600 hover:text-pink-700 ml-1">
              https://ec.europa.eu/consumers/odr/
            </a><br />
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>
          
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
          <p className="mb-4">
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
          
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Haftung für Inhalte</h2>
          <p className="mb-4">
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
            allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
            verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen
            zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
          <p className="mb-4">
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
            Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt
            der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
            Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
          </p>
          
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Haftung für Links</h2>
          <p className="mb-4">
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
            Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
          </p>
          
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Urheberrecht</h2>
          <p className="mb-4">
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
            Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
            Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
          
          <div className="mt-12 pt-8 border-t border-gray-200">
            <a
              href="/"
              className="inline-block bg-pink-600 text-white px-6 py-3 rounded-lg hover:bg-pink-700 transition-colors"
            >
              Zurück zur Startseite
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
